import type { JobItemDto } from "@artha/api-contracts";
import { normalizeCountryCode } from "./normalizers";

export const RESUME_ELIGIBILITY_CPA_THRESHOLDS = {
  IN: 1,
  US: 50,
} as const;

export type ResumeEligibilityCountry =
  keyof typeof RESUME_ELIGIBILITY_CPA_THRESHOLDS;

export type ResumeEligibilityResult = {
  eligible: boolean;
  country: ResumeEligibilityCountry | null;
  cpaValue: number | null;
  threshold: number | null;
};

export const evaluateResumeEligibility = (
  job: Pick<JobItemDto, "country" | "cpa_value">,
): ResumeEligibilityResult => {
  const normalizedCountry = normalizeCountryCode(job.country || "");
  const country = Object.prototype.hasOwnProperty.call(
    RESUME_ELIGIBILITY_CPA_THRESHOLDS,
    normalizedCountry,
  )
    ? (normalizedCountry as ResumeEligibilityCountry)
    : null;
  const cpaValue =
    typeof job.cpa_value === "number" && Number.isFinite(job.cpa_value)
      ? job.cpa_value
      : null;
  const threshold = country ? RESUME_ELIGIBILITY_CPA_THRESHOLDS[country] : null;

  return {
    eligible:
      country !== null &&
      cpaValue !== null &&
      threshold !== null &&
      cpaValue > threshold,
    country,
    cpaValue,
    threshold,
  };
};
